import React, { createContext, useState } from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
const DynamicThemeProvider = ({
  children,
  theme
}) => {
  const [mainColor, setMainColor] = useState(null);
  return /*#__PURE__*/React.createElement(DynamicThemeContext.Provider, {
    key: mainColor || 'themeProvider',
    value: {
      mainColor,
      setMainColor
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createTheme(theme(mainColor))
  }, children));
};
const DynamicThemeContext = /*#__PURE__*/createContext();
DynamicThemeProvider.propTypes = {
  theme: PropTypes.func.isRequired
};
export { DynamicThemeContext, DynamicThemeProvider };